// extracted by mini-css-extract-plugin
export default {"hub_card":"a-","img":"b-","title":"c-","button":"e-","account_hub_card":"f-","label":"g-"};
    if(module.hot) {
      // 1713969938177
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  